import { useEffect } from "react";

const SchemaMarkup = () => {
  useEffect(() => {
    const MAIN_DOMAIN = "https://rakibhossentopu.online";
    
    // Person Schema
    const personSchema = {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Rakib Hossen Topu",
      "alternateName": ["Rakib Hassan", "Rakib Hassan Topu", "SEO Expert in BD"],
      "jobTitle": "SEO Expert in BD | Digital Marketing Specialist Bangladesh",
      "description": "Rakib Hossen Topu is a professional SEO Expert in Bangladesh with 5+ years of experience in Local SEO, E-commerce SEO, YouTube SEO, and Digital Marketing.",
      "email": "rakibhassantopu@gmail.com",
      "telephone": "+8801862772430",
      "url": MAIN_DOMAIN,
      "image": `${MAIN_DOMAIN}/images/rakib-hero.webp`,
      "nationality": {
        "@type": "Country",
        "name": "Bangladesh"
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Dhaka",
        "addressRegion": "Dhaka Division",
        "addressCountry": "BD"
      },
      "sameAs": [
        "https://www.facebook.com/rakibhossentopu",
        "https://www.linkedin.com/in/rakibhossentopu",
        "https://x.com/rakibhassantopu",
        "https://www.instagram.com/rakibhossentopu/"
      ],
      "knowsAbout": [
        "SEO Expert",
        "SEO Expert in BD",
        "SEO Expert in Bangladesh",
        "Search Engine Optimization",
        "Digital Marketing",
        "Local SEO",
        "E-commerce SEO",
        "YouTube SEO",
        "Technical SEO",
        "Content Marketing",
        "International SEO",
        "SEO Analytics",
        "Google Ranking",
        "Meta Ads"
      ],
      "worksFor": {
        "@type": "Organization",
        "name": "Freelance SEO Consultant"
      }
    };

    // Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Rakib Hossen Topu - SEO Expert in BD",
      "alternateName": "SEO Expert Bangladesh",
      "url": MAIN_DOMAIN,
      "description": "Rakib Hossen Topu is a professional SEO Expert in BD offering Local SEO, E-commerce SEO, YouTube SEO & Digital Marketing services in Bangladesh.",
      "inLanguage": "en-BD",
      "author": {
        "@type": "Person",
        "name": "Rakib Hossen Topu"
      },
      "publisher": {
        "@type": "Person",
        "name": "Rakib Hossen Topu"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${MAIN_DOMAIN}/?s={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    };

    // Professional Service Schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Rakib Hossen Topu - SEO Services",
      "description": "Professional SEO and Digital Marketing services including Local SEO, E-commerce SEO, Technical SEO, Content Marketing, International SEO, and SEO Analytics.",
      "url": MAIN_DOMAIN,
      "telephone": "+8801862772430",
      "email": "rakibhassantopu@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Dhaka",
        "addressCountry": "Bangladesh"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "23.8103",
        "longitude": "90.4125"
      },
      "areaServed": [
        {
          "@type": "Country",
          "name": "Bangladesh"
        },
        {
          "@type": "Place",
          "name": "Worldwide"
        }
      ],
      "serviceType": [
        "Local SEO",
        "E-commerce SEO",
        "Technical SEO",
        "Content Marketing",
        "International SEO",
        "SEO Analytics",
        "Digital Marketing"
      ],
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      }
    };

    // Create and inject script tags
    const scripts: HTMLScriptElement[] = [];
    
    const createSchemaScript = (schema: object, id: string) => {
      const existingScript = document.getElementById(id);
      if (existingScript) {
        existingScript.remove();
      }
      
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    };

    createSchemaScript(personSchema, "person-schema");
    createSchemaScript(websiteSchema, "website-schema");
    createSchemaScript(serviceSchema, "service-schema");

    // Cleanup on unmount
    return () => {
      scripts.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
};

export default SchemaMarkup;
